export const regexp = `[a-zA-Z\u0459\u045a\u0435\u0440\u0442\u0437\u0443\u0438\u043e\u043f
\u0448\u0452\u0430\u0441\u0434\u0444\u0433\u0445\u0458\u043a
\u043b\u0447\u045b\u0436\u0455\u045f\u0446\u0432\u0431\u043d\u043c
\u0161\u0111\u010d\u0107\u017e]`
